<template>
  <div class="admin-settings">
    <section-title>{{ $t('view.settings.admin.accountSettings') }}</section-title>
    <section-title subsection>{{ $t('view.settings.admin.dataTitle') }}</section-title>
    <div class="admin-settings__section admin-settings__basic-section editor-section">
      <div
        class="editor-section-description"
      >{{ $t('view.settings.admin.description.basic') }}</div>
      <div class="admin-settings__input-container">
        <in
          class="admin-settings__input"
          v-model="admin.name"
          :label="$t('view.settings.admin.name')"
          @blur="onBlurInputValidation(validateName(), invalidAdmin.badNameFormat)"
          @enter="validateAdmin"
        ></in>
        <in
          class="admin-settings__input"
          v-model="admin.username"
          :label="$t('view.settings.admin.username')"
          @blur="onBlurInputValidation(validateUsername(), invalidAdmin.badUsernameFormat)"
          @enter="validateAdmin"
        ></in>
        <in
          class="admin-settings__input settings__input__margins"
          v-model="admin.email"
          :label="$t('view.settings.admin.email')"
          @blur="onBlurInputValidation(validateEmail(), invalidAdmin.badEmailFormat)"
          @enter="validateAdmin"
        ></in>
      </div>
      <div class="admin-settings__validate-text">{{ invalidAdminText }}</div>
      <btn
        class="admin-settings__basic-section-button"
        icon="save"
        @click="validateAdmin"
      >{{ $t('btn.save') }}</btn>
    </div>
    <section-title subsection>{{ $t('view.settings.admin.notificationsTitle') }}</section-title>
    <div class="admin-settings__section admin-settings__notif-section editor-section">
      <div
        class="editor-section-description"
      >{{ $t('view.settings.admin.description.notif') }}</div>
      <sw-button
        class="admin-settings__notif-section-switches"
        :label="$t('view.settings.admin.requestsNotif')"
        v-model="admin.notification_requests_active"
      ></sw-button>
      <sw-button
        class="admin-settings__notif-section-switches"
        :label="$t('view.settings.admin.statsNotif')"
        v-model="admin.notification_statistics_active"
      ></sw-button>
      <sw-button
        class="admin-settings__notif-section-switches"
        :label="$t('view.settings.admin.techNotif')"
        v-model="admin.notification_technical_active"
      ></sw-button>
      <btn
        class="admin-settings__basic-section-button"
        icon="save"
        @click="saveEditedAdmin"
      >{{ $t('btn.save') }}</btn>
    </div>
    <section-title subsection>{{ $t('view.settings.admin.securityTitle') }}</section-title>
    <div class="admin-settings__section admin-settings__basic-section editor-section">
      <div
        class="editor-section-description"
      >{{ $t('view.settings.admin.description.security') }}</div>
      <div class="admin-settings__input-container">
        <in
          class="admin-settings__input"
          type="password"
          passwordAutofillDisabled
          v-model="credentials.password"
          :label="$t('view.settings.admin.password')"
        ></in>
        <in
          class="admin-settings__input"
          type="password"
          passwordAutofillDisabled
          v-model="credentials.newPassword"
          :label="$t('view.settings.admin.newPassword')"
          :invalid="notSamePasswords"
        ></in>
        <in
          class="admin-settings__input settings__input__margins"
          type="password"
          passwordAutofillDisabled
          v-model="repeatNewPassword"
          :label="$t('view.settings.admin.repeatNewPassword')"
          :invalid="notSamePasswords"
          @enter="validateCredentials"
        ></in>
      </div>
      <div class="admin-settings__validate-text">{{ invalidCredentialsText }}</div>
      <btn
        class="admin-settings__basic-section-button"
        icon="save"
        @click="validateCredentials"
      >{{ $t('btn.save') }}</btn>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import axios from '@/axios'

export default {
  data () {
    return {
      admin: JSON.parse(JSON.stringify(this.$store.state.user.admin)),
      credentials: {
        password: 'password',
        newPassword: null
      },
      repeatNewPassword: null,

      invalidCredentials: {
        notSame: {
          text: this.$t('validation.admin.other.notSame.text'),
          flag: false
        }
      },

      invalidAdmin: {
        badNameFormat: {
          text: this.$t('validation.admin.format.name'),
          flag: false
        },
        badEmailFormat: {
          text: this.$t('validation.admin.format.email'),
          flag: false
        },
        badUsernameFormat: {
          text: this.$t('validation.admin.format.username'),
          flag: false
        }
      }
    }
  },

  computed: {
    notSamePasswords: function () {
      /* if(!this.credentials.newPassword && !this.repeatNewPassword) return false */
      if (this.credentials.newPassword !== this.repeatNewPassword) {
        this.invalidCredentials.notSame.flag = true
        return true
      }
      this.invalidCredentials.notSame.flag = false
      return false
    },

    invalidCredentialsText: function () {
      let text = ''
      const keys = Object.keys(this.invalidCredentials)
      for (const key of keys) {
        if (this.invalidCredentials[key].flag) {
          text += this.invalidCredentials[key].text + ' '
        }
      }
      return text
    },

    invalidAdminText: function () {
      let text = ''
      const keys = Object.keys(this.invalidAdmin)
      for (const key of keys) {
        if (this.invalidAdmin[key].flag) {
          text += this.invalidAdmin[key].text + ' '
        }
      }
      return text
    }
  },

  methods: {
        onBlurInputValidation (validationResult, toSet) {
      if (validationResult) toSet.flag = false
      else toSet.flag = true
    },

    //// FIELDS
    validateName () {
      if (!this.admin.name) return true
      const reg = /^[a-zA-Z]+( [a-zA-Z]+)*$/
      if (reg.test(this.admin.name) && this.admin.name.length < 32) return true
      return false
    },

    validateUsername () {
      if (!this.admin.username) return true
      const reg = /^[a-zA-Z]+( [a-zA-Z]+)*$/
      if (reg.test(this.admin.username) && this.admin.username.length < 32) return true
      return false
    },

    validateEmail () {
      if (!this.admin.email) return true
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return reg.test(this.admin.email.toLowerCase())
    },

    //// SECTIONS
    validateAdmin () {
      if (!this.admin.username || !this.admin.name) {
        this.notify('error', 'validation.admin.empty.edit')
        return
      }
      if (!this.validateName() || !this.validateUsername() || !this.validateEmail()) {
        this.notify('error', 'validation.admin.format.edit')
        return
      }
      this.saveEditedAdmin()
    },

    validateCredentials () {
      if (!this.credentials.newPassword && !this.repeatNewPassword) {
        this.notify('error', 'validation.admin.empty.newPassword')
        return
      }
      if (this.notSamePasswords) {
        this.notify('error', 'validation.admin.other.notSame')
        return
      }
      this.saveCredentials()
    },

    //// REQUESTS
    async saveEditedAdmin () {
      try {
        await axios.put('/api/account/update', {
          data: {
            admins: [this.admin]
          }
        })
        store.commit('UPDATE_ADMIN', this.admin)
        this.admin = JSON.parse(JSON.stringify(this.$store.state.user.admin))
        this.notify('success', 'view.settings.success.general')
      } catch (e) {
        console.error(e)
        this.notify('error', 'view.settings.error.general')
      }
    },

    async saveCredentials () {
      try {
        await axios.put('/api/account/update-password', {
          data: {
            credentials: this.credentials
          }
        })
        this.notify('success', 'view.settings.success.credentials')
      } catch (e) {
        console.error(e)
        this.notify('error', 'view.settings.error.credentials')
      }
    }
  }
}
</script>

<style lang="scss">
.admin-settings {
  &__section {
    margin-bottom: 80px;
    position: relative;
    width: 34vw;
    min-width: 540px;
  }

  &__basic-section {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  &__input-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }

  &__input {
    width: 32%;

    &__margins {
      margin-top: 0px;
    }
  }

  &__validate-text {
    position: absolute;
    top: calc(100% + 18px);
    left: calc(8px);
    text-transform: uppercase;
    font-weight: 500;
    font-family: "Work Sans";
    font-size: 0.7em;
    letter-spacing: 0.01em;
    color: $danger;
  }

  &__basic-section-button {
    position: absolute;
    top: calc(100% + 18px);
    right: 0;
  }

  &__notif-section-switches {
    width: 140px;
  }
}
</style>
